const PARTNER_REOLVE_LINK_LAMDA_URL = "https://partners.kahun.com/moreinfo";

export function getPartnerUrl(
  partnerId: string,
  featureId: string,
  hostName?: string,
  extraVars?: string,
) {
  return `${PARTNER_REOLVE_LINK_LAMDA_URL}?partner=${partnerId.toLowerCase()}&feature=${featureId}${(hostName
    ? `&host-override=${encodeURIComponent(hostName)}`
    : "") + (extraVars ? `&${extraVars}` : "")}`;
}
